<p-accordionTab #importFinalUsersDiv>
	<ng-template pTemplate="header">
		<div class="grid flex align-items-center w-full pt-2 -mb-2">
			<div [class]="!onExtendedMobile() ? 'col-12' : 'col-12 flex justify-content-center'" class="py-0">
				<span class="font-semibold white-space-nowrap">{{'IMPORT_LIST_FINAL_USERS' | translate }}</span>
			</div>
		</div>
	</ng-template>
	<div *ngIf="editing || deleting">
		<div class="flex align-items-center justify-content-center w-full pb-8 mb-8">
			<p-progressSpinner ariaLabel="loading"></p-progressSpinner>
		</div>
	</div>
	<div class="grid" *ngIf="!editing && !deleting">
		<div class="col-12 flex align-items-center justify-content-center bg-yellow-200 p-1 border-round-xl"
			*ngIf="totalRecords <= 0">
			<p-tag icon="pi cm-alert" [value]="('NONE_LIST_FINAL_USERS_WARNING' | translate)" severity="warning"
				styleClass="text-lg"></p-tag>
		</div>
		<div class="col-12 p-0" *ngIf="totalRecords > 0">
			<div class="card">
				<p-table #tableImportFinalUsers [value]="finalUsersLists" [paginator]="true" [totalRecords]="totalRecords"
					[rows]="pageSize" [showCurrentPageReport]="true"
					currentPageReportTemplate="{{ 'TABLE_REPORT' | translate }}" [autoLayout]="true" responsiveLayout="stack"
					[loading]="finalUsersLoading" (onLazyLoad)="loadFiles($event)" sortField="created_at" [sortOrder]="-1">
					<ng-template pTemplate="header">
						<tr>
							<th>
								<div pSortableColumn="name" class="flex align-items-center justify-content-center">
									{{ 'NAME' | translate }}
									<p-sortIcon field="name"></p-sortIcon>
								</div>
							</th>
							<th>
								<div pSortableColumn="created_at" class="flex align-items-center justify-content-center">
									{{ 'CREATED_AT' | translate }}
									<p-sortIcon field="created_at"></p-sortIcon>
								</div>
							</th>
							<th>
								<div pSortableColumn="updated_at" class="flex align-items-center justify-content-center">
									{{ 'UPDATED_AT' | translate }}
									<p-sortIcon field="updated_at"></p-sortIcon>
								</div>
							</th>
							<th>
							</th>
						</tr>
					</ng-template>
					<ng-template pTemplate="body" let-list>
						<tr>
							<td>
								<span class="p-column-title font-semibold">{{ 'NAME' | translate }}</span>{{list.Name}}
							</td>
							<td>
								<span class="p-column-title font-semibold">{{ 'CREATED_AT' | translate }}</span>{{list.CreatedAt
								|
								localizedDate: 'medium'}}
							</td>
							<td>
								<span class="p-column-title font-semibold">{{ 'UPDATED_AT' | translate }}</span>{{list.UpdatedAt
								|
								localizedDate: 'medium'}}
							</td>
							<td>
								<span class="p-column-title font-semibold">
								</span>
								<div class="flex flex-row justify-content-center align-items-center gap-1">
									<p-button label="{{'IMPORT_LIST' | translate }}" tooltipPosition="bottom"
										icon="pi cm-cloud-arrow-down" size="large" (click)="importList(list)" [rounded]="false"
										[text]="true" severity="primary">
									</p-button>
									<p-button pTooltip="{{ 'EDIT_NAME' | translate }} {{ ('LIST' | translate).toLowerCase() }}"
										tooltipPosition="bottom" icon="pi cm-pencil" size="large" (click)="editList(list)"
										[rounded]="false" [text]="true" severity="secondary">
									</p-button>
									<p-button pTooltip="{{ 'DELETE_LIST' | translate }}" tooltipPosition="bottom"
										icon="pi cm-trash" size="large" (click)="deleteList(list)" [rounded]="false" [text]="true"
										severity="danger">
									</p-button>
								</div>
							</td>
						</tr>
					</ng-template>
					<ng-template pTemplate="emptymessage">
						<tr>
							<td colspan="7">{{ 'TABLE_NO_ELEMENT' | translate }}</td>
						</tr>
					</ng-template>
				</p-table>
			</div>
		</div>
	</div>

	<p-confirmDialog #confDialog>
		<ng-template pTemplate="footer">
			<div class="col-12 flex justify-content-center">
				<button type="button" pButton [label]="confDialog.acceptButtonLabel" [ngClass]="acceptButtonStyle"
					(click)="confDialog.accept()">
				</button>
				<button type="button" pButton [label]="confDialog.rejectButtonLabel" [ngClass]="rejectButtonStyle"
					(click)="confDialog.reject()">
				</button>
			</div>
		</ng-template>
	</p-confirmDialog>
</p-accordionTab>